import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/inter-latin-wght-normal.woff2\",\"variable\":\"--font-inter\",\"display\":\"swap\",\"weight\":\"100 900\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/layouts/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopFade"] */ "/vercel/path0/src/components/layouts/top-fade/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/components/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
